import React, {memo} from 'react';
import {View} from 'react-native';
import {createUseStyle} from '@redlink/assets/styles';
import {Text, Space, IconPlus, IconButton, IconNegative} from '@redlink/components/atoms';
import {useMoneyMask} from '@redlink/core';
import {useLocale} from '@redlink/assets/locale';
import {Button} from '@redlink/components/molecules';
import {modifyProductBasket} from '@redlink/services';

export const ProductBasketItem = memo(({item: {item, count}}) => {
    const {styles, colors} = useStyle();
    const {getValue} = useMoneyMask();
    const {dictionary} = useLocale();
    const {title, price, discount} = item;

    const finalPrice = price - discount;
    const finalPriceText = `${getValue(finalPrice)} ${dictionary.moneyPostfix}`;

    return (
        <View style={styles.container}>
            <Text style={styles.titleText}>{title}</Text>
            <Space size={8}/>
            <View style={styles.numbersContainer}>
                <Text style={styles.priceText}>{finalPriceText}</Text>
                <View style={styles.countButtonsContainer}>
                    <IconButton style={styles.countButton} disabled={count === 0}
                                onPress={() => {
                                    modifyProductBasket({item, count: count - 1});
                                }}>
                        <IconNegative color={colors.white}/>
                    </IconButton>
                    <Text style={styles.countText}>{count}</Text>
                    <IconButton style={styles.countButton}
                                onPress={() => {
                                    modifyProductBasket({item, count: count + 1});
                                }}>
                        <IconPlus color={colors.white}/>
                    </IconButton>
                </View>
            </View>
        </View>
    );
});

const useStyle = createUseStyle(({colors, size, ltrFlexDirection}) => ({
    container: {
        flex: 1,
        backgroundColor: colors.background,
    },
    titleText: {
        color: colors.title,
        fontSize: 16,
        fontWeight: 'bold',
    },
    priceText: {
        flex: 1,
        fontSize: 16,
        color: colors.title,
    },
    numbersContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    countButtonsContainer: {
        flexDirection: ltrFlexDirection,
        alignItems: 'center',
    },
    countButton: {
        width: 24,
        height: 24,
        padding: 0,
        borderRadius: 5,
        backgroundColor: colors.green1
    },
    countText: {
        color: colors.primary,
        fontSize: 16,
        flex: 1,
        textAlign: 'center',
        width: 35,
    },
}));
